/**
 * Analytics types for GenAI Studio v2
 */

// Screen action types
export enum AiGenScreenAction {
  GENERATE = 'generate',
  GENERATE_CLICK = 'generate_click',
  RETRY = 'retry',
  DISMISS_ERROR = 'dismiss_error',
  UPLOAD = 'upload',
  DOWNLOAD = 'download',
  CANCEL = 'cancel',
  EDIT = 'edit',
  BACK = 'back',
  CLICK = 'click',
  SHARE = 'share',
  DELETE = 'delete',
  REPORT = 'report',
  REUSE_TEMPLATE = 'reuse_template',
  LIKE = 'like',
  DISLIKE = 'dislike',
  TRENDING_ITEM_CLICK = 'trending_item_click',
  CHIP_CLICK = 'chip_click',
  SEE_ALL = 'see_all',
  OPEN = 'feed_open',
  SWIPE_UP = 'swipe_up',
  SWIPE_DOWN = 'swipe_down',
  PROFILE_OPEN = 'profile_open',
  CREDITS_OPEN = 'credits_open',
  GET_MORE = 'get_more',
  SAVE = 'save',
  UNSAVE = 'unsave',
}

// Screen type values
export enum ScreenType {
  GENERATOR = 'generator_screen',
  CHOOSER = 'chooser_screen',
  HISTORY = 'history',
  PREVIEW = 'preview_screen',
  PRESET_FEED = 'preset_feed',
  PROFILE = 'profile',
  CREDITS = 'credits',
}

// Entry point for the preset feed open event
export type PresetFeedOpenSource = 'click' | 'deeplink';

export enum ClickItem {
  Category = 'category',
  Effect = 'effect',
}

// Settings object for analytics
export interface AnalyticsSettings {
  category: string;
  id?: string;
}

// Extended settings for failure cases (error fields required)
export interface AnalyticsSettingsWithError extends AnalyticsSettings {
  error_type: string;
  error_message: string;
}
